module.exports = __webpack_public_path__ + "img/zhantie.59c2b1fd.png";